/**
 * GA4, Meta Pixel, Google Ads Events Tracking
 * @author Robert Sachetti, sro.at
 */

(function () {
  let initialized = false;

  function dwCheckConsent() {
    if (initialized) return;
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;

    const consent = window.Shopify.customerPrivacy.currentVisitorConsent();

    if (!consent) return;

    if (consent.analytics || consent.marketing) {
      initialized = true;
      dwInitEvents();
    }
  }

  document.addEventListener("visitorConsentCollected", function () {
    dwCheckConsent();
  });

  const interval = setInterval(function () {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      dwCheckConsent();
      clearInterval(interval);
    }
  }, 200);

  setTimeout(function () {
    clearInterval(interval);
  }, 10000);
})();

function dwInitEvents() {
  dwInitScroll();
  dwInitCartPage();
  dwInitPhoneLinks();
  dwInitEmailLinks();
  dwInitNewsletterSignup();
  dwInitProductFinder();
  dwInitSearch();
  dwInitLogin();
  dwInitRegister();
  dwInitGuideView();
  dwInitLeadGuide();
  dwInitFileDownload();
  dwInitExternalLinks();
  dwInitContactForm();
  dwInitYouTubeVideoTracking();
  dwInitHeroCta();
  dwInitGclidRestore();
}

function dwInitScroll() {
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  const scrollMilestones = [25, 50, 75, 90];

  let trackedMilestones = new Set();

  let maxScroll = 0;

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function getScrollPercent() {
    const h = document.documentElement;
    const b = document.body;
    const st = "scrollTop";
    const sh = "scrollHeight";

    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
  }

  function sendScrollEvent(percentage) {
    gtag("event", "scroll", {
      percent_scrolled: percentage,
    });
  }

  const handleScroll = debounce(() => {
    const scrollPercent = Math.round(getScrollPercent());

    maxScroll = Math.max(maxScroll, scrollPercent);

    scrollMilestones.forEach((milestone) => {
      if (maxScroll >= milestone && !trackedMilestones.has(milestone)) {
        trackedMilestones.add(milestone);
        sendScrollEvent(milestone);
      }
    });
  }, 100);

  window.addEventListener("scroll", handleScroll);

  window.addEventListener("beforeunload", () => {
    handleScroll();
  });
}

function dwTrackViewCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "view_cart", {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: cart.items.map((item) => ({
            item_id: item.id.toString(),
            item_name: item.product_title,
            item_variant: item.variant_title || "",
            price: item.price / 100,
            quantity: item.quantity,
          })),
          url: window.location.pathname,
          titel: document.title,
        });
      }
      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        gtag("event", "conversion", {
          send_to: "AW-812177364/C_CJCMKS94McENSvo4MD",
        });
      }
    })
    .catch((error) => {});
}

function dwInitCartPage() {
  if (window.themeVariables?.settings?.pageType === "cart") {
    dwTrackViewCart();
  }

  const miniCart = document.getElementById("mini-cart");
  if (miniCart) {
    let lastTracked = 0;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === "open" && miniCart.hasAttribute("open")) {
          const now = Date.now();
          if (now - lastTracked < 1000) return;
          lastTracked = now;
          dwTrackViewCart();
        }
      }
    });
    observer.observe(miniCart, { attributes: true, attributeFilter: ["open"] });
  }
}

function dwInitPhoneLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("tel:")) return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "contact", {
          phone: window.location.pathname,
        });
      }

      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        gtag("event", "conversion", {
          send_to: "AW-812177364/I6jTCPOo94McENSvo4MD",
        });

        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "Contact");
        }
      }
    } catch (e) {}
  });
}

function dwInitEmailLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("mailto:")) return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "contact", {
          mail: window.location.pathname,
        });
      }

      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        gtag("event", "conversion", {
          send_to: "AW-812177364/EsFVCPao94McENSvo4MD",
        });

        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "Contact");
        }
      }
    } catch (e) {}
  });
}

function dwTrackNewsletterRegistration() {
  try {
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      gtag("event", "newsletter_registration", {
        url: window.location.pathname,
        titel: document.title,
      });
    }
    if (window.Shopify.customerPrivacy.marketingAllowed()) {
      gtag("event", "conversion", {
        send_to: "AW-812177364/e42QCO2o94McENSvo4MD",
      });
      if (typeof window.fbq !== "undefined") {
        window.fbq("track", "Subscribe");
      }
    }
  } catch (e) {}
}

function dwInitNewsletterSignup() {
  const tagInput = document.querySelector('input[name="contact[tags]"][value="newsletter"]');
  if (tagInput) {
    const form = tagInput.closest("form");
    if (form) {
      form.addEventListener("submit", function () {
        if (typeof form.checkValidity === "function" && !form.checkValidity()) {
          return;
        }
        dwTrackNewsletterRegistration();
      });
    }
  }

  const nlSubmit = document.getElementById("nlSubmit");
  if (nlSubmit) {
    nlSubmit.addEventListener("click", function () {
      const emailInput = document.getElementById("nlEmail");
      if (!emailInput || !emailInput.value || !emailInput.value.includes("@")) return;
      dwTrackNewsletterRegistration();
    });
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest("button");
    if (!button) return;

    const form = button.closest('form[data-testid^="klaviyo-form"]');
    if (!form) return;

    if (!button.textContent.includes("Gratis Leitfaden sichern")) return;

    dwTrackNewsletterRegistration();

    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      gtag("event", "generate_lead", {
        url: window.location.pathname,
        titel: document.title,
      });
    }
    if (window.Shopify.customerPrivacy.marketingAllowed()) {
      gtag("event", "conversion", {
        send_to: "AW-812177364/uxpsCPCo94McENSvo4MD",
      });

      if (typeof window.fbq !== "undefined") {
        window.fbq("track", "Lead");
      }
    }
  });
}

function dwInitSearch() {
  if (!window.location.pathname.endsWith("/search")) return;

  const params = new URLSearchParams(window.location.search);

  if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
    gtag("event", "search", {
      url: window.location.pathname,
      titel: document.title,
      suchbegriff: params.get("q") || "",
    });
  }

  if (window.Shopify.customerPrivacy.marketingAllowed()) {
    if (typeof window.fbq !== "undefined") {
      window.fbq("track", "Search");
    }
  }
}

function dwInitLogin() {
  if (!window.location.pathname.endsWith("/account/login")) return;
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  gtag("event", "login_page_view", {
    url: window.location.pathname,
    titel: document.title,
  });

  const form = document.getElementById("customer_login");
  if (form) {
    form.addEventListener("submit", function () {
      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        return;
      }
      gtag("event", "login", {
        url: window.location.pathname,
        titel: document.title,
      });
    });
  }
}

function dwInitRegister() {
  if (!window.location.pathname.endsWith("/account/register")) return;

  if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
    gtag("event", "register_page_view", {
      url: window.location.pathname,
      titel: document.title,
    });
  }

  const form = document.getElementById("register-customer");
  if (form) {
    form.addEventListener("submit", function () {
      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        return;
      }
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "registration", {
          url: window.location.pathname,
          titel: document.title,
        });
      }
      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        gtag("event", "conversion", {
          send_to: "AW-812177364/nvv6CMWS94McENSvo4MD",
        });

        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "CompleteRegistration");
        }
      }
    });
  }
}

function dwInitGuideView() {
  if (!window.location.pathname.includes("/anleitungen/")) return;
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  gtag("event", "guide_view", {
    url: window.location.pathname,
    titel: document.title,
  });
}

function dwInitLeadGuide() {
  const button = document.getElementById("add-to-cart-guide");
  if (!button) return;

  button.addEventListener("click", function () {
    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "generate_lead", {
          url: window.location.pathname,
          titel: document.title,
        });
      }
      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "Lead");
        }
      }
    } catch (e) {}
  });
}

function dwInitFileDownload() {
  document.addEventListener("click", function (event) {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || !href.toLowerCase().endsWith(".pdf")) return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "file_download", {
          url: window.location.pathname,
          titel: document.title,
          file: href,
        });
      }
    } catch (e) {}
  });
}

function dwInitExternalLinks() {
  document.addEventListener("click", function (event) {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href) return;

    try {
      const url = new URL(href);
      const domain = url.hostname.replace("www.", "");

      if (domain.includes("gustagarden.com")) return;

      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "link_click", {
          url: href,
          titel: document.title,
        });
      }
    } catch (e) {}
  });
}

function dwInitContactForm() {
  if (!window.location.pathname.endsWith("/pages/contact")) return;

  const form = document.getElementById("contact_form");
  if (!form) return;

  form.addEventListener("submit", function () {
    if (typeof form.checkValidity === "function" && !form.checkValidity()) {
      return;
    }
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      gtag("event", "contact", {
        form: "contact",
      });
    }

    if (window.Shopify.customerPrivacy.marketingAllowed()) {
      gtag("event", "conversion", {
        send_to: "AW-812177364/0Xv5CPmo94McENSvo4MD",
      });

      if (typeof window.fbq !== "undefined") {
        window.fbq("track", "Contact");
      }
    }
  });
}

function dwInitProductFinder() {
  document.addEventListener("click", function (event) {
    const link = event.target.closest("a.js-submit.quick-nav__submit");
    if (!link) return;
    if (!link.textContent.includes("Produkte suchen") && !link.textContent.includes("search products")) return;

    const href = link.getAttribute("href");
    if (!href || href === "#") return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        gtag("event", "product_finder_used", {
          url: window.location.pathname,
          titel: document.title,
          produkt: href,
        });
      }
    } catch (e) {}
  });
}

function dwInitYouTubeVideoTracking() {
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  var iframes = document.querySelectorAll('iframe[src*="youtube.com/embed"]');
  if (iframes.length === 0) return;

  if (!window.YT || !window.YT.Player) {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function onYTReady(callback) {
    if (window.YT && window.YT.Player) {
      callback();
    } else {
      setTimeout(function () {
        onYTReady(callback);
      }, 500);
    }
  }

  onYTReady(function () {
    iframes.forEach(function (iframe) {
      if (!iframe.src.includes("enablejsapi=1")) {
        iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
      }

      var videoStarted = false;
      var videoCompleted = false;
      var videoTitle = "";
      var videoDuration = 0;
      var progressInterval = null;
      var progressMilestones = [10, 25, 50, 75];
      var trackedMilestones = new Set();

      new window.YT.Player(iframe, {
        events: {
          onReady: function (event) {
            try {
              videoTitle = event.target.getVideoData().title || "";
              videoDuration = event.target.getDuration() || 0;
            } catch (e) {}
          },
          onStateChange: function (event) {
            var player = event.target;

            if (event.data === window.YT.PlayerState.PLAYING) {
              if (!videoStarted) {
                videoStarted = true;
                try {
                  videoTitle = player.getVideoData().title || videoTitle;
                  videoDuration = player.getDuration() || videoDuration;
                } catch (e) {}

                gtag("event", "video_start", {
                  video_provider: "youtube",
                  video_title: videoTitle,
                  video_url: iframe.src,
                  visible: true,
                  video_duration: videoDuration,
                  video_current_time: 0,
                  video_percent: 0,
                });
              }

              if (!progressInterval) {
                progressInterval = setInterval(function () {
                  try {
                    var current = Math.floor(player.getCurrentTime());
                    var percent = videoDuration > 0 ? Math.round((current / videoDuration) * 100) : 0;
                    progressMilestones.forEach(function (milestone) {
                      if (percent >= milestone && !trackedMilestones.has(milestone)) {
                        trackedMilestones.add(milestone);
                        gtag("event", "video_progress", {
                          video_provider: "youtube",
                          video_title: videoTitle,
                          video_url: iframe.src,
                          visible: true,
                          video_duration: videoDuration,
                          video_current_time: current,
                          video_percent: milestone,
                        });
                      }
                    });
                  } catch (e) {}
                }, 1000);
              }
            } else {
              if (progressInterval) {
                clearInterval(progressInterval);
                progressInterval = null;
              }

              if (event.data === window.YT.PlayerState.ENDED && !videoCompleted) {
                videoCompleted = true;
                try {
                  videoTitle = player.getVideoData().title || videoTitle;
                  videoDuration = player.getDuration() || videoDuration;
                } catch (e) {}

                gtag("event", "video_complete", {
                  video_provider: "youtube",
                  video_title: videoTitle,
                  video_url: iframe.src,
                  visible: true,
                  video_duration: videoDuration,
                  video_current_time: videoDuration,
                  video_percent: 100,
                });
              }
            }
          },
        },
      });
    });
  });
}

function dwInitHeroCta() {
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  const isCoffeeSoil = window.location.pathname.endsWith("/pages/kaffeeerde-tchibo-waldaffe-gusta-garden");

  document.addEventListener("click", function (event) {
    const link = event.target.closest("a.hero-cta");
    if (!link) return;

    gtag("event", "hero_cta_click", {
      url: window.location.pathname,
      titel: document.title,
    });

    if (isCoffeeSoil) {
      gtag("event", "coffeesoil_cta_click", {
        url: window.location.pathname,
        titel: document.title,
      });
    }
  });
}

function dwInitGclidRestore() {
  if (!window.Shopify.customerPrivacy.marketingAllowed()) return;

  var COOKIE_NAME = "_gcl_aw";
  var COOKIE_NAME_P = "GCL_AW_P";
  var CLICK_PARAM = "lnid";
  var MAX_AGE = 90 * 24 * 60 * 60;

  var url = window.location.href;
  var isHttps = url.indexOf("https://") === 0;

  var COOKIE_OPTIONS = {
    domain: "auto",
    path: "/",
    maxAge: MAX_AGE,
    sameSite: "Lax",
    secure: isHttps,
  };

  function hasParam(name) {
    var q = url.indexOf("?");
    if (q === -1) return false;
    return ("&" + url.substring(q + 1)).indexOf("&" + name + "=") !== -1;
  }

  function getParamRaw(name) {
    var q = url.indexOf("?");
    if (q === -1) return null;
    var parts = url.substring(q + 1).split("&");
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split("=");
      if (kv[0] === name) return kv.length > 1 ? kv[1] : "";
    }
    return null;
  }

  function buildSeedTs() {
    return "GCL." + (((Date.now() + 500) / 1000) | 0);
  }

  function getCookieValue(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  function setCookie(name, value, options) {
    var cookieString = name + "=" + value;
    if (options.path) cookieString += "; path=" + options.path;
    if (options.maxAge) cookieString += "; max-age=" + options.maxAge;
    if (options.sameSite) cookieString += "; samesite=" + options.sameSite;
    if (options.secure) cookieString += "; secure";
    if (options.domain === "auto") {
      var hostname = window.location.hostname;
      if (hostname.indexOf(".") !== -1) {
        var parts = hostname.split(".");
        if (parts.length >= 2) {
          cookieString += "; domain=." + parts.slice(-2).join(".");
        }
      }
    } else if (options.domain) {
      cookieString += "; domain=" + options.domain;
    }
    document.cookie = cookieString;
  }

  function writeCookies(value) {
    setCookie(COOKIE_NAME, value, COOKIE_OPTIONS);
    setCookie(COOKIE_NAME_P, value, COOKIE_OPTIONS);
  }

  try {
    if (hasParam("gclid")) return;
    var lnidRaw = getParamRaw(CLICK_PARAM);
    if (!lnidRaw) return;

    var existing = getCookieValue(COOKIE_NAME) || "";
    if (!existing) {
      writeCookies(buildSeedTs() + "." + lnidRaw);
      return;
    }

    var firstDot = existing.indexOf(".");
    var secondDot = firstDot === -1 ? -1 : existing.indexOf(".", firstDot + 1);
    if (secondDot === -1) {
      writeCookies(existing + "." + lnidRaw);
    }
  } catch (e) {}
}
